/** Central motion tokens - one source for framer-motion + CSS transitions. */
/** Mandated motion-token surface (AGENTS.md) - adopt in new animations. @public */
export const DURATION = { fast: 150, base: 200, slow: 300 } as const

/** Standard ease - matches the Radix/Tailwind enter/exit feel. */
export const EASING = [0.4, 0, 0.2, 1] as const

/** Default spring for layout/position transitions. */
export const SPRING = { type: 'spring', stiffness: 300, damping: 35 } as const

/** Chat messages and similar arrivals: a quick rise that settles softly. */
export const ENTER_EASING = [0.22, 1, 0.36, 1] as const
